// extracted by mini-css-extract-plugin
module.exports = {"root":"n10-meta_root__qgFR7","wrapper":"n10-meta_wrapper__iJ838","content":"n10-meta_content__YRfS3","list":"n10-meta_list__fnBy1","link":"n10-meta_link__AJIns"};